import { render } from "./edit-expense.vue?vue&type=template&id=0d72f49e"
import script from "./edit-expense.vue?vue&type=script&lang=js"
export * from "./edit-expense.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__